export default __webpack_public_path__ + "static/media/donutLove.456fef85.png";